// Base
import type { Blueprint } from '@builder/base/blueprints/Blueprint';
import type { AggregateBlueprint } from '@builder/base/blueprints/AggregateBlueprint';
import { instanceOfAggregateBlueprint } from '@builder/base/blueprints/AggregateBlueprint';
import type { ValidationErrors } from '@builder/base/types/ValidationErrors';
import type { ValidatableBlueprint } from '@builder/base/blueprints/ValidatableBlueprint';
import { validateBlueprints } from '@builder/base/blueprints/ValidatableBlueprint';

// Blueprints
import type { BlueprintDefinition } from '@builder/form/blueprints/BlueprintDefinition';
import type { VisibleBlueprint } from '@builder/form/blueprints/VisibleBlueprint';
import type { PageBlueprint } from '@builder/form/blueprints/PageBlueprint';

// Traits
import type { HasTitle } from '@builder/form/traits/HasTitle';
import type { HasDescription } from '@builder/form/traits/HasDescription';

// Enums
import { AlwaysChoice } from '@builder/form/enums/AlwaysChoice';
import type { NeverChoice } from '@builder/form/enums/NeverChoice';
import type { InternallyChoice } from '@builder/form/enums/InternallyChoice';
import type { WhenChoice } from '@builder/form/enums/WhenChoice';

// --------------------------------------------------

export const Definition: BlueprintDefinition = {
    type: 'page',
    name: '[[[Strona]]]',
    group: 'none'
};

export interface PageContract extends PageBlueprint, AggregateBlueprint, VisibleBlueprint, HasTitle, HasDescription
{
    prevButtonText: Record<string, string>;
    nextButtonText: Record<string, string>;
}

export class PageType implements PageContract, ValidatableBlueprint
{
    public kind: 'page' = 'page' as const;
    public id: string;
    public type: string;
    public name: string;
    public components: Blueprint[];
    public title: Record<string, string>;
    public showTitle: boolean;
    public description: Record<string, string>;
    public prevButtonText: Record<string, string>;
    public nextButtonText: Record<string, string>;
    public visible: AlwaysChoice | NeverChoice | InternallyChoice | WhenChoice;
    public visibleWhen: string;
    public errors: ValidationErrors;

    public constructor(id: string, name: string)
    {
        this.id = id;
        this.type = Definition.type;
        this.name = name;
        this.components = [];
        this.title = {};
        this.showTitle = false;
        this.description = {};
        this.prevButtonText = {};
        this.nextButtonText = {};
        this.components = [];
        this.visible = AlwaysChoice.Always;
        this.visibleWhen = null;
        this.errors = {};
    }

    public validate(): Record<string, ValidationErrors>
    {
        this.errors = {};

        return validateBlueprints(this.components);
    }
}

export const instanceOfPageType = (object: any): object is PageType =>
{
    return instanceOfAggregateBlueprint(object) && 'type' in object && object.type === Definition.type;
};
